import ConnectedAccountsSideBarItem from './SideBarItem'

export default ConnectedAccountsSideBarItem
